<template>
    <div class="buyflow-panel">
        <div class="font-bold text-center desktop:text-left text-lg mb-4">
           {{ isFiber ? 'High-speed fiber gateway rental is required' : (isMinimal? 'A High-speed Gateway rental is included in your promotion!' :'Do you need to lease a high-speed gateway?')}}
        </div>
        <div class="flex flex-col space-y-4">
            <div class="buyflow-subpanel
                        space-y-6">
                <!-- High-Speed Modem only (OPEN SYNC) -->
                <ModemOption v-if="modemOnly.isVisible && !isMinimal"
                             title="High-Speed Gateway"
                             subtitle="Internet Gateway Lease"
                             :is-selected="isEquipmentSelected(modemOnly) || isEquipmentSelected(mainEquipment)"
                             :price="modemOnly.promoPrice"
                             @select="$emit('select-options', { modem: { decision: modemOnly.decision, selection: modemOnly }})">
                    <div>
                        A Gateway contains a High-Speed Internet Modem.<br>
                        24/7 Remote Support Enabled.
                    </div>
                </ModemOption>

                <hr v-if="modemOnly.isVisible && !isMinimal">

                <!-- WiFi Your Way (Regular/Fiber) + 2 WiFi Pods + N extra WiFi Pods -->
                <ModemOption
                    :title="isMinimal ? 'Would you like to upgrade to WiFi Your Way&trade; Home?' : 'WiFi Your Way&trade; Home'"
                    :subtitle="isFiber ? 'Fiber Gateway Rental' : 'WiFi Coverage Extension'"
                    :is-recommended="!isFiber && !isMinimal"
                    :is-selected="isEquipmentSelected(mainEquipment)"
                    :price="mainEquipment.promoPrice"
                        :isFiber="isFiber">
                    <div
                        class="desktop:grid grid-cols-12 gap-6 mb-6">
                        <div class="mb-4 col-start-1 col-span-4">
                            <img src="/temp/wifi-your-way.webp" class="max-w-1/2 mx-auto  desktop:max-w-full" height="150" alt="wifi your way">
                        </div>
                        <div class="col-span-12 desktop:col-span-8">
                            WiFi Your Way&trade; Home <strong>extends WiFi coverage</strong> to every inch of your home, and
                            provides better security, parental controls, and a dedicated App. Everything needed for a
                            reliably fast, whole home WiFi network.
                        </div>
                    </div>
                    <template v-if="!isFiber"
                              v-slot:trigger>
                        <template v-if="isEquipmentSelected(mainEquipment)">
                            <AppModal modal-type="danger">
                                <template #trigger>
                                    <button
                                        class="buyflow-button active flex items-center"
                                        :disabled="isFiber">
                                        <IconCheck class="mr-1" />
                                        Selected
                                    </button>
                                </template>
                                <template #contents>
                                    <div class="text-base font-bold mb-2">
                                        Are you sure you want a High-Speed Gateway only (without WiFi Your Way&trade; Home) for the same price?
                                    </div>
                                    <div class="text-sm mt-3 font-normal">
                                        The following will not be included:
                                        <div class="mt-1">
                                            <IconXmark class="inline mr-1 flex-shrink-0" />
                                            <strong class="mr-1">Not Included:</strong> WiFi Management App and Parental Controls
                                        </div>
                                        <div>
                                            <IconXmark class="inline mr-1 flex-shrink-0" />
                                            <strong class="mr-1">Not Included:</strong> Best in class security powered by AI
                                        </div>
                                        <div>
                                            <IconXmark class="inline mr-1 flex-shrink-0" />
                                            <strong class="mr-1">Not Included:</strong> Adaptive network that helps prevent dead spots
                                        </div>
                                    </div>
                                </template>
                                <template #confirm>
                                    <button type="button"
                                    class="buyflow-button mt-5"
                                    :disabled="isFiber"
                                    @click.prevent="removeWYW()">
                                        Confirm Selection
                                    </button>
                                </template>
                            </AppModal>

                        </template>
                        <template v-else-if="isEquipmentSelected(modemOnly)">
                            <button type="button"
                                    class="buyflow-button"
                                    @click.prevent="$emit('select-options', { equipment: { decision: mainEquipment.decision, selection: mainEquipment }})">
                                Select
                            </button>
                        </template>
                        <template v-else>
                            <button type="button"
                                    class="buyflow-button"
                                    :disabled="true">
                                Add gateway first
                            </button>
                        </template>
                    </template>
                    <template v-slot:extra>
                        <ExtraPods class="mt-6 desktop:mt-4"
                                   :in-cart="extraPodsInCart"
                                   v-bind="extraPodsData"
                                   v-on="$listeners" />
                    </template>
                </ModemOption>
            </div>

            <div v-if="noModem.isVisible && !isMinimal"
                 class="buyflow-subpanel">
                <!-- Decline -->
                <ModemOption
                        title="I have my own equipment"
                        subtitle="You can use your own modem but you will not get the following features:"
                        :is-selected="isEquipmentSelected(noModem)"
                        @select="$emit('select-options', {
                            modem: { decision: noModem.decision, selection: noModem },
                            equipment: { decision: mainEquipment.decision, selection: null },
                            pods: { decision: extraPodsData.decision, selection: null, quantity: 0}})">
                    <ul class="cons">
                        <li>
                            <IconCircleExclamation class="inline mr-1 flex-shrink-0" />
                            <span>
                                No 24/7 support for your modem and WiFi service.
                            </span>
                        </li>
                        <li>
                            <IconCircleExclamation class="inline mr-1 flex-shrink-0" />
                            <span>
                                No integrated Parental Controls and device security.
                            </span>
                        </li>
                        <li>
                            <IconCircleExclamation class="inline mr-1 flex-shrink-0" />
                            <span>
                                No home phone service available (requires a Breezeline-provided modem).
                            </span>
                        </li>
                        <li>
                            <IconCircleExclamation class="inline mr-1 flex-shrink-0" />
                            <span>
                                Your modem might not be compatible, please check
                                <a href="/assets/documents/2023_approved_modems.pdf"
                                   target="_blank"
                                   class="underline">
                                    our compatibility list.
                                </a>
                            </span>
                        </li>
                    </ul>
                </ModemOption>
            </div>
        </div>
    </div>
</template>

<script>
    import AppModal from '~/Buyflow/components/AppModal'
    import AppVideoPlayer from '~/Buyflow/components/AppVideoPlayer'
    import PricePerMonth from '@/atoms/PricePerMonth'
    import ModemOption from './modemOption'
    import ExtraPods from './extraPods'
    import IconCheck from "@/atoms/icons/IconCheck"
    import IconXmark from "@/atoms/icons/IconXmark"
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"
    import { mapGetters } from 'vuex'
    export default {
        name: 'InternetEquipments',
        components: {
            AppModal,
            AppVideoPlayer,
            PricePerMonth,
            ModemOption,
            ExtraPods,
            IconCheck,
            IconXmark,
            IconCircleExclamation,
        },
        props: {
            marketType: {
                type: String,
                required: true,
                default: 'default',
            },
            selectedInternet: {
                type: Object,
                required: true,
            },
            modemOptions: {
                type: Object,
                required: true,
            },
            wywOptions: {
                type: Object,
                required: true,
            },
            isEquipmentSelected: {
                type: Function,
                required: true,
            },
            extraPodsData: {
                type: Object,
                required: true,
            },
            extraPodsInCart: {
                type: Number,
                default: 0,
            },
            isMinimal: {
                type: Boolean,
                default: false
            },
        },
        computed: {
			...mapGetters({
				isFiber: 'Buyflow/internet/isFiber',
			}),
            noModem() {
                return this.modemOptions.noModem
            },
            modemOnly() {
                if (this.modemOptions.modemOnlyWithDiscount.isVisible && ['Base Internet', 'Core', 'Fast', 'Unlimited Fast'].indexOf(this.selectedInternet.name) > -1){
                    return this.modemOptions.modemOnlyWithDiscount
                }
                return this.modemOptions.modemOnly
            },
            modemWithOnePod() {
                return this.wywOptions.modemWithOnePod
            },
            modemWithTwoPods() {
                return this.wywOptions.modemWithTwoPods
            },
            fiberModem() {
                return this.wywOptions.fiberModem
            },
            mainEquipment() {
                const modem = this.modemWithOnePod.isVisible? this.modemWithOnePod: this.modemWithTwoPods

                // If the market type contains fiber, return the fiber modem, otherwise return the modem
                return this.isFiber? this.fiberModem: modem
            },
        },
        methods: {
            showWYWModal() {
                // for tracking
            },
            removeWYW() {
                this.$emit('select-options', {
                    equipment: { decision: this.mainEquipment.decision, selection: null },
                    pods: { decision: this.extraPodsData.decision, selection: null, quantity: 0}});
                this.$store.dispatch('adjustOpenOverlaysCounter', { value: false }) // close modal
            },
        },
    }
</script>

<style lang="scss" scoped>
    ul.cons {
        @apply desktop:pr-4;

        li {
            @apply mb-2
                   flex
                   flex-row
                   space-x-4
                   items-center
                   leading-snug;

            i {
                @apply text-salmon
                       text-lg desktop:text-sm;
            }
        }
    }
</style>
